import {findHeader} from 'features/provide-custom-link/lib/find-header';
import {HEADER_TAGS} from 'features/provide-custom-link/model/constants';
import {getSessionId} from 'store/slices/auth-slice/auth-slice-api';

/**
 * Функция для получения кастомных хедеров (USER_SESSION_ID) для запроса
 *
 * @param {{[key: string]: string} | null | undefined} params - набор кастомных хедеров
 *
 * @returns {[string, string] | []} customHeaders - хедер с SessionId или пустой макссив
 */
export const getCustomHeaders = async (params: {[key: string]: string} | null | undefined) => {
    const customHeaders = [];

    try {
        const userSessionHeader = findHeader(params, HEADER_TAGS.USER_SESSION_ID);

        if (userSessionHeader) {
            const session = await getSessionId();

            if (session?.data) {
                customHeaders.push([
                    userSessionHeader.key, session.data,
                ]);
            }
        }
    } catch (error) {
        console.error(error, 'Ошибка получения custom headers');
    }

    return customHeaders;
};
